import { Grid } from "@material-ui/core";
import * as React from "react";
import { ConfigurationAssetComponent } from "./components/AssetConfiguration/ConfigurationAssetComponent";

export const ConfigurationAssetPage = () => {
	return (
		<>
			<Grid container justifyContent="center" alignItems="center">
				<ConfigurationAssetComponent />
			</Grid>
		</>
	);
};
